<template>
  <b-overlay
  :show="loading"
  rounded="lg">
    <b-card title="Delivery Picking Process">
      <b-col cols="4">
        <b-button variant="primary" :to="{ name: 'ongoing-delivery-picking' }" size="sm">
          <feather-icon size="1x" icon="ArrowLeftIcon" /> Back to Ongoing Delivery Picking
        </b-button>
      </b-col>
      <br />
      <b-col cols="12">
        <b-row>
          <b-col cols="12" style="margin-top:10px">
            <b-row>
              <b-col cols="4"><strong>SO Number</strong></b-col>
              <b-col>: {{ delivery[0] ? delivery[0].orderNumber : '' }}</b-col>
            </b-row>
            <b-row>
              <b-col cols="4"><strong>Order Date</strong></b-col>
              <b-col>: {{ delivery[0] ? setDate(delivery[0].createdAt) : '' }}</b-col>
            </b-row>
            <b-row>
              <b-col cols="4"><strong>Delivery Address 1</strong></b-col>
              <b-col>: {{ delivery[0] ? delivery[0].deliveryAddressOne : '' }}</b-col>
            </b-row>
            <b-row>
              <b-col cols="4"><strong>Delivery Address 2</strong></b-col>
              <b-col>: {{ delivery[0] ? delivery[0].deliveryAddressTwo : '' }}</b-col>
            </b-row>
            <br>
            <br>
            <b-table
              :items="delivery"
              :fields="fieldPicklistReadOnly"
              responsive="xl"
              hover
              head-variant="dark"
              outlined
              small
              class="table-responsive"
              sticky-header
            >
              <template #cell(no)="row">
                {{ row.index + 1 }}
              </template>
              <template #cell(statusDelivery)="row">
                {{ setStatus(row.item.props) }}
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
      <br />
    </b-card>
  </b-overlay>
</template>
  
  <script>
  import { dateFormat} from "@/utils/utils.js";
  import { mapActions } from "vuex";
  
  export default {
    props: ["sonumber"],
    data() {
      return {
        fieldPicklistReadOnly: [
          { key: "no", label: "No" },
          { key: "picklistNumber", label: "Pick List Number" },
          { key: "lineItem", label: "Line Item" },
          { key: "lineDescription", label: "Line Description" },
          { key: "fromBatch", label: "Drum Number" },
          { key: "pickListType", label: "Pick List Type" },
          { key: "quantity", label: "Quantity" },
          { key: "unit", label: "Unit" },
          { key: "binLocation", label: "Bin Location" },
          { key: "props.statusNo", label: "Status" },
          { key: "cableLengthInfo", label: "Cable Length" },
          { key: "cableWeight", label: "Cable Weight" },
          { key: "machineName", label: "Machine" },
          { key: "user", label: "Cutter" },
          { key: "statusDelivery", label: "Status Delivery" }
        ],
        loading: false,
        startTimer: null,
        totalTimer: "",
        ongoingDelivery: ""
      };
    },
  
    methods: {
      ...mapActions({
        getPicklist: "picklist/getPicklist",
      }),
      async fetchData(){
        const data = await this.getPicklist({
            orderNumber: this.sonumber,
        });
        let picklist = data.data.filter(el => el.pickListType != "R")
        let hasDelivery = picklist.some((element) => {
            return element.props.DPS !== undefined && element.props.DPE === undefined;
        });
        if (hasDelivery) {
            this.ongoingDelivery = picklist.filter(el => el.props.DPS !== undefined && el.props.DPE === undefined).map(el => el.picklistNo + "_" + el.picklistLine)
        } else {
            this.ongoingDelivery = ""
        }
      },
      setDate(date) {
        return dateFormat(date)
      },
      setStatus(props) {
        if(!props.DPS){
          return "Ready to Deliver"
        }else if(!props.DPS && !props.DPE){
          return "Ongoing Delivery"
        } else {
          return "Delivery Finished"
        }
      }
    },
  
    created() {
      document.title = "Delivery Picking Process | Tai Sin";
    },
    computed: {
      delivery() {
        let delivery = this.$store.getters["picklist/getPicklist"].filter(el => el.pickListType != "R").map(el => {
          var newOrderDate = dateFormat(el.orderDate).split(",")
          return {
            ...el,
            orderDate : newOrderDate[0] + newOrderDate[1].replace(/\./g, ':'),
            picklistNumber : el.picklistNo + "_" + el.picklistLine,
            machineName : el.pickListType === 'C'? el.props.machineName || 'Not Set Up' : ""
          }
        })
        delivery.sort((a, b) => {
          if (a.picklistNo !== b.picklistNo) {
              return a.picklistNo - b.picklistNo;
          } else {
              return a.picklistLine - b.picklistLine;
          }
      });
        return delivery;
      }
    },
    
    mounted() {
      this.fetchData()
    },
  };
  </script>
  
  <style scoped>
  .scrollable-table {
    overflow-x: auto;
    width: 100%;
  }
  </style>
  